import { KeyMetrics } from "@/components/financials/KeyMetrics";
import { RevenueChart } from "@/components/financials/RevenueChart";
import { ProjectionsTable } from "@/components/financials/ProjectionsTable";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const Financials = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="max-w-7xl mx-auto space-y-6">
        <KeyMetrics />
        <RevenueChart />
        <ProjectionsTable />
      </div>
    </QueryClientProvider>
  );
};

export default Financials;